import { render, staticRenderFns } from "./AssessmentReport.vue?vue&type=template&id=73dcd260&scoped=true"
import script from "./AssessmentReport.vue?vue&type=script&lang=ts"
export * from "./AssessmentReport.vue?vue&type=script&lang=ts"
import style0 from "./AssessmentReport.vue?vue&type=style&index=0&id=73dcd260&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dcd260",
  null
  
)

export default component.exports